export default __webpack_public_path__ + "static/media/login-tit.52963c62.png";